/* eslint-disable react/require-default-props */
/* eslint-disable no-unused-vars */
import { Box, Dialog, IconButton, Link } from "@mui/material";
import React from "react";
import { eventTracking } from "../../../firebase/firebaseConfig";
import { TDataAdsInHouse } from "../../common/utils/type";
import { handlePostActionClickAdsInHouse } from "../utils/commonAPI";

type TProps = {
  adsInHouse?: TDataAdsInHouse;
};

function AdsInHouseBlock({ adsInHouse }: TProps) {
  return (
    <Box>
      <Link
        key={adsInHouse?.activity_uid}
        href={adsInHouse?.link}
        onClick={() =>
          eventTracking("select_home_ads_item", { link: adsInHouse?.link, item_id: adsInHouse?.activity_uid }, () => {
            handlePostActionClickAdsInHouse(adsInHouse?.activity_uid);
          })
        }
        id="home_page_ads_in_house_item"
      >
        <a href={adsInHouse?.link} target="_blank" rel="noreferrer">
          <img src={adsInHouse?.media} alt={adsInHouse?.content} className="object-scale-down rounded-[16px]" />
        </a>
      </Link>
    </Box>
  );
}

export default AdsInHouseBlock;
